import {Pipe, PipeTransform} from '@angular/core';
import {DomSanitizer, SafeHtml} from "@angular/platform-browser";

@Pipe({
    name: 'evidenceSvg',
    standalone: true
})
export class EvidenceSvgPipe implements PipeTransform {

    constructor(private sanitizer: DomSanitizer) {
    }

    transform(value: string): SafeHtml {
        const imgMap: Record<string, string> = {
            basic: 'assets/images/certstates/basic.svg',
            basiccert: 'assets/images/certstates/basiccert.svg',
            high: 'assets/images/certstates/high.svg',
            max: 'assets/images/certstates/max.svg',
        };

        const src = imgMap[value];
        if (!src) {
            return this.sanitizer.bypassSecurityTrustHtml('');
        }

        const title = value.toUpperCase();
        const imgTag = `<img width="100%" src="${src}" alt="${value}" title="${title}">`;

        return this.sanitizer.bypassSecurityTrustHtml(imgTag);
    }
}
